import axios, { CancelToken } from "axios"
import { SortingCriteria } from "./interfaces/SortingCriteria"
import { FacturaRecurrenteReadingFiltersDtoIPagedEnumerableProps } from "./Schemas/FacturaRecurrenteReadingFiltersDtoIPagedEnumerable"
import { DocumentoRecurrenteEstadoType } from "./Types/DocumentoRecurrenteEstado"
import { DocumentoRecurrenteIntervaloType } from "./Types/DocumentoRecurrenteIntervalo"

export interface FacturaRecurrenteByFiltersQueryParamsProps {
  CreationEmpresaId?: string
  Estado?: DocumentoRecurrenteEstadoType[]
  FechaEmisionLowerLimit?: string
  FechaEmisionUpperLimit?: string
  ImporteLowerLimit?: number
  ImporteUpperLimit?: number
  Intervalo?: DocumentoRecurrenteIntervaloType[]
  RazonSocial?: string
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}

/**
 * Retrieves a paginated list of recurrent invoices filtered by the specified query parameters.
 *
 * @param queryParams - The filter criteria for retrieving recurrent invoices.
 * @param cancelToken - (Optional) Axios cancel token to cancel the request if needed.
 * @returns A promise that resolves to a paginated enumerable of recurrent invoice DTOs.
 */
export async function getFacturasRecurrentesByFilter(
  queryParams: FacturaRecurrenteByFiltersQueryParamsProps,
  cancelToken?: CancelToken
): Promise<FacturaRecurrenteReadingFiltersDtoIPagedEnumerableProps> {
  const { data } = await axios.get("/FacturaRecurrente/by-filters", {
    params: queryParams,
    cancelToken,
  })
  return data
}
